/* eslint-disable array-element-newline */
import {nothing} from 'lit';
import {FacetRangeSlider} from '../facet-range-slider/facet-range-slider';
import styles from './facet-step-slider.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class FacetStepSlider extends FacetRangeSlider {
	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	get sliderOptions () {
		return {
			...super.sliderOptions,
			direction: 'rtl',
			pips: {
				format: this.facet?.custom?.noUiSlider?.format,
				mode: 'values',
				stepped: true,
				values: this.facet?.custom?.noUiSlider?.values
			}
		};
	}

	constructor () {
		super();
	}

	renderRangeInputs () {
		return nothing;
	}

	highlightSelectedPips (low, high) {
		const valueElements = this.slider?.value?.querySelectorAll('.noUi-pips .noUi-value');

		valueElements.forEach((element) => {
			const index = Math.round(Number(element.dataset.value));
			if (index >= low && index <= high) {
				element.classList.add('is-selected');
			}
			else {
				element.classList.remove('is-selected');
			}
		});
	}

	updated () {
		super.updated();
		this.highlightSelectedPips(...this.parseFormattedValues(this.slider?.value?.noUiSlider?.get()));
	}

	parseFormattedValues (formattedValues) {
		return formattedValues
			.map(value => parseInt(value, 10));
	}

	handleChange (formattedValues, handleNumber, values) {
		super.handleChange(formattedValues, handleNumber, values);
		const [low, high] = this.parseFormattedValues(formattedValues);

		this.highlightSelectedPips(low, high);
	}
};

defineCustomElement('rb-facet-step-slider', FacetStepSlider);
